import * as React from 'react';
import { MapPageFormFilter } from './Filters';
import { Input } from 'antd';

interface ContractFilterProps extends MapPageFormFilter {
    
}

export default function TreeIdFilter(props: ContractFilterProps) {
  const { value: formValue, onChange: updateForm, isLoading } = props;
  const [value, setValue] = React.useState('');
  
  return (
    <Input
      disabled={isLoading}
      type="text"
      className="tree-id-input"
      // Digits-only keypad on phones; `pattern` keeps iOS on that keypad too
      inputMode="numeric"
      pattern="[0-9]*"
      placeholder={'Type tree ID'}
      value={formValue || value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        // Tree IDs are numeric: anything else is dropped as it is typed or pasted
        const digits = e.target.value.replace(/[^0-9]/g, '');
        setValue(digits);
        updateForm && updateForm(digits);
      }}
    />
  );
}